window.arjoProductListWithSubCategoryModule =
  window.arjoProductListWithSubCategoryModule ||
  (() => {
    const state = {
      isInitialized: false,
      elements: {},
    };

    const setUp = () => {
      const elements = [...document.querySelectorAll('.arjo-o-product-list-with-sub-category')];
      elements.forEach((element) => {
        const id = element.dataset.listId;
        const innerState = {
          domNode: element,
          expanded: false,
          sortBy: undefined,
          filterByLv1Category: undefined,
          filterByLv2Category: undefined,
          data: [],
        };

        const grid = innerState.domNode.querySelector('.arjo-o-product-list-with-sub-category__grid');

        const setData = (data) => {
          innerState.data = [...data];
        };

        const createProductCardHtml = (product) => {
          /*product schema
            {
              "isNew": true,
              "timestamp": 1,
              "badge": "New",
              "url": "#",
              "pictureProperties": {
                "sources": [
                  {
                    "media": "(min-width:768px)",
                    "srcSet": "/04.jpg"
                  }
                ],
                "default": {
                  "src": "/02.jpg",
                  "alt": "Product"
                }
              },
              "category": "Hospital beds",
              "categoryLv1Id": [
              "1",
              "4"
              ],
              "categoryLv2Id": {
                "1": [
                  "1",
                  "2"
                ],
                "4": [
                  "1",
                  "2"
                ]
              },
              "heading": "Maxi Sky 2 Plus",
              "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris non velit sagittis, pulvinar nisl vel, feugiat ligula."
            }
          */
          const badgeHtml = product.isNew ? `<div class="arjo-o-product-card__badge">${product.badge}</div>` : '';
          const pictureHtml = (() => {
            let html = '';
            if (!product.pictureProperties) return html;
            html += `<picture class="arjo-a-picture">`;
            product.pictureProperties.sources.forEach((source) => {
              html += `<source media="${source.media}" srcset="${source.srcSet}" />`;
            });
            html += `<img src="${product.pictureProperties.default.src}" alt="${product.pictureProperties.default.alt}" loading="lazy"/>`;
            html += `</picture>`;
            return html;
          })();

          return `
            <div class="arjo-o-product-card arjo-card ${product.isNew ? 'arjo-o-product-card--new' : ''} arjo-o-product-card--categoried" 
                  data-timestamp="${product.timestamp}">
              <div style="display: none;" data-category-lv1-id>
                ${JSON.stringify(product.categoryLv1Id)}
              </div>
              <div style="display: none;" data-category-lv2-id>
                ${JSON.stringify(product.categoryLv2Id)}
              </div>
              <a href="${product.url}" class="arjo-o-product-card__link">
                <div class="arjo-o-product-card__head">
                  ${badgeHtml}
                  <div class="arjo-o-product-card__tag">${product.category}</div>
                </div>
                <div class="arjo-o-product-card__picture">
                  ${pictureHtml}
                </div>
                <h5 class="arjo-o-product-card__heading">${product.heading}</h5>
                <div class="arjo-o-product-card__description">${product.description}</div>
              </a>
            </div>         
          `;
        };

        const updateDom = () => {
          let dataForRender;
          switch (innerState.sortBy) {
            case '0':
              dataForRender = [...innerState.data].sort((a, b) => {
                return b.timestamp.localeCompare(a.timestamp);
              });
              break;
            case '1':
              dataForRender = [...innerState.data].sort((a, b) => {
                return a.heading.localeCompare(b.heading);
              });
              break;
            default:
              dataForRender = [...innerState.data];
              break;
          }

          switch (innerState.filterByLv1Category) {
            case '0':
            case null:
            case undefined:
              break;
            default:
              dataForRender = [...dataForRender.filter((product) => product.categoryLv1Id.includes(innerState.filterByLv1Category))];
              break;
          }

          switch (innerState.filterByLv2Category) {
            case '0':
            case null:
            case undefined:
              break;
            default:
              dataForRender = [
                ...dataForRender.filter(
                  (product) =>
                    product.categoryLv2Id[innerState.filterByLv1Category] !== undefined &&
                    product.categoryLv2Id[innerState.filterByLv1Category].includes(innerState.filterByLv2Category)
                ),
              ];
              break;
          }

          const cards = grid.querySelectorAll('.arjo-o-product-card');
          cards.forEach((card) => {
            card.remove();
          });
          dataForRender.forEach((data) => {
            grid.innerHTML += createProductCardHtml(data);
          });

          if (dataForRender.length <= 9) {
            innerState.domNode.classList.remove('arjo-o-product-list-with-sub-category--hide-expander-tablet');
            innerState.domNode.classList.add('arjo-o-product-list-with-sub-category--hide-expander');
          } else if (dataForRender.length <= 12) {
            innerState.domNode.classList.remove('arjo-o-product-list-with-sub-category--hide-expander');
            innerState.domNode.classList.add('arjo-o-product-list-with-sub-category--hide-expander-tablet');
          } else {
            innerState.domNode.classList.remove('arjo-o-product-list-with-sub-category--hide-expander');
            innerState.domNode.classList.remove('arjo-o-product-list-with-sub-category--hide-expander-tablet');
          }

          if (innerState.expanded) {
            grid.classList.add('arjo-o-product-list-with-sub-category__grid--show-all');
          } else {
            grid.classList.remove('arjo-o-product-list-with-sub-category__grid--show-all');
          }
        };

        const setState = ({ expanded, sortBy, filterByLv1Category, filterByLv2Category }) => {
          innerState.expanded = expanded;
          innerState.sortBy = sortBy;
          innerState.filterByLv1Category = filterByLv1Category;
          innerState.filterByLv2Category = filterByLv2Category;
          updateDom();
        };

        const getState = () => {
          return {
            expanded: innerState.expanded,
            sortBy: innerState.sortBy,
            filterByLv1Category: innerState.filterByLv1Category,
            filterByLv2Category: innerState.filterByLv2Category,
          };
        };

        const expander = element.querySelector('.arjo-m-button-expander');
        expander?.addEventListener('change', (e) => {
          setState({
            expanded: e.target.checked,
            sortBy: innerState.sortBy,
            filterByLv1Category: innerState.filterByLv1Category,
            filterByLv2Category: innerState.filterByLv2Category,
          });
          if (e.target.checked) return;

          if (window.arjoJs.isMobile()) {
            grid.querySelectorAll('.arjo-o-product-card ')[8].scrollIntoViewEx();
          } else {
            grid.querySelectorAll('.arjo-o-product-card ')[11].scrollIntoViewEx();
          }
        });
        state.elements[id] = {
          setData,
          setState,
          get currentState() {
            return getState();
          },
        };
      });
    };

    const init = () => {
      if (state.isInitialized) return;
      setUp();
      state.isInitialized = true;
    };

    const getElement = (id) => {
      return state.elements[id];
    };

    return { init, getElement };
  })();

window.addEventListener('load', window.arjoProductListWithSubCategoryModule.init);
